<section class="jumbotron text-center my-2">
  <h1 class="jumbotron-heading">SIMULADOR DE AUDIENCIAS UTPL</h1>
  <!-- <h6>Espacio virtual diseñado para interactuar con las funcionalidades del simulador de audiencias.
  </h6> -->
</section>    

<!-- accordion -->
<section class="jumbotron text-center my-1 section1 px-5">

  <span class="d-grid gap-2 d-md-flex justify-content-md-end">
    <a class="btn btn-warning me-md-2 m-2" href="./assets/SimuladorAudiencias1_2.rar"
    target="_blank" download="SimuladorAudiencias1_2.rar"
    >Descargar simulador <img width="20px" src="./assets/img/windows.png"/></a>
  </span>
  <div class="accordion p-2" id="accordion1">
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingOne">
        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          Objetivo general:
        </button>
      </h2>
      <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion1">
        
        <div class="accordion-body2 p-2">
          <div class="jumbotron-heading" class="style6_1" style="text-align: justify">
            <svg width="2%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"/></svg>  
            Brindar un aplicativo en el cual se desarrollen casos jurídicos mediante la práctica de una audiencia real en un entorno virtual.
          </div>  
        </div>  
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingTwo">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
          Características:
        </button>
      </h2>
      <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordion1">
        <div class="accordion-body2 p-2">
          <div class="jumbotron-heading" class="style6_1" style="text-align: justify">
            <span class="m-2 p-1"> <svg width="2%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"/></svg>  
              Permite al docente designar, a cada uno de sus estudiantes, los roles que existen en una audiencia real.
            </span><br>
            <span class="m-2 p-1"> <svg width="2%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg> 
              Facilita la comunicación entre docente y estudiantes, mediante el uso de voz y texto.
            </span><br>
            <span class="m-2 p-1"> <svg width="2%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"/></svg>  
              Permite generar salas de prácticas simultaneas con una capacidad de 50 estudiantes cada una.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<section class="jumbotron text-center my-4 section111 py-0 px-5" style="background: rgb(212, 212, 212);">
  
  <div class="row background1" >
    <div class="padding1"> 
      <section class="jumbotron text-center ">

        <div class="row row-cols-1 row-cols-md-3 g-4">
          <div class="col">
            <div class="card h-100 text-bg-secondary mb-3" >
              <img src="./assets/img/1.jpg" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Acceso</h5>
                <p class="card-text">Los usuarios ingresan digitando su número de identificación personal.</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img src="./assets/img/2.jpg" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Sala</h5>
                <p class="card-text">El docente crea la sala de simulación antes del acceso de sus estudiantes.</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img src="./assets/img/3.jpg" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Personaje</h5>
                <p class="card-text">Cada usuario del sistema debe elegir un avatar antes de su ingreso.</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img src="./assets/img/4.jpg" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Comunicación</h5>
                <p class="card-text">Los usuarios pueden comunicarse en el sistema gracias a la presencia del chat de voz y texto.</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img src="./assets/img/5.jpg" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Ubicación</h5>
                <p class="card-text">De acuerdo al rol asignado por el docente, cada estudiante debe ocupar su lugar en la sala.</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img src="./assets/img/6.jpg" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Salir</h5>
                <p class="card-text">Los usuarios deben abandorar el sistema de manera segura.</p>
              </div>
            </div>
          </div>
        </div>

      </section> 
    </div>
  </div>   
</section>


<section class="jumbotron text-center my-4">
<div class="container  mt-4" class="style2">
  <div>
    <div class="row">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h1 class="jumbotron-heading">¡Conoce sobre nuestro simulador de audiencias virtualizado!</h1>
          <h5 class="jumbotron-heading">Observa el video introductorio y luego descarga el instalador de la aplicación, instálala y experimenta por ti mismo.</h5>
          <h3 class="jumbotron-heading">¡Te sorprenderás!</h3>
        </div>
      </div>
    </div>
  </div>
  <div>
    <section class="jumbotron text-center my-2 style3">
      <div class="container mt-4">
        <div class="row">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-8">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/qVJxMyNB5xk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
    &nbsp;&nbsp;
    <div>
      <div class="row">
        <div class="col-12 text-center" style="background:#fff">
          <div class="section-title">
            <h2 class="jumbotron-heading">¡Descarga el aplicativo y experimenta por ti mismo!</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center" style="background:#fff">
          <div class="section-title mb-4 pb-12">
            <a class="btn btn-dark margin1" href="./assets/SimuladorAudiencias1_2.rar"
            target="_blank"
            download="SimuladorAudiencias1_2.rar"
            >Simulador de audiencias ( S.O. Windows  &nbsp;<img width="37px" src="./assets/img/windows.png"/> &nbsp;)</a>&nbsp;
            
            <a class="btn btn-dark margin3" href="./assets/Manual_Instal_Uso_SimulAud.pdf"
            target="_blank"
            download="Manual_Instal_Uso_SimulAud.pdf"
            >Manual de instalación y uso 
            &nbsp;&nbsp;<img width="35px" src="./assets/img/manual.png"/> </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</section>  
<section class="jumbotron text-center my-2 style3">
<div class="container  mt-4">
  <div class="row">
    <div class="col-12 text-center">
      <div class="section-title mb-4 pb-2">
        <h1 class="jumbotron-heading"><span class="style4"> Equipo docente</span></h1>
      </div>
    </div>
  </div>
</div>
<div  class="py-2 team4">
  <div  class="container">
    <div class="row justify-content-center">
      <div class="col-lg-4 mb-4">
        <div class="card">
          <div class="row text-center">
            <div class="col-md-12">
              <img class="card-img-top"
              src="./assets/img/ROLANDO_DAVID_ANDRADE_HIDALGO.jpg"
              alt="Card image cap">
            </div>
            <div class="card-body">
              <h5 class="card-title">ROLANDO DAVID ANDRADE HIDALGO</h5><hr />
              <h6>Docente investigador UTPL</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-4">
        <div class="card">
          <div class="row text-center">
            <div class="col-md-12">
              <img class="card-img-top" 
              src="./assets/img/PAUL_JAVIER_MORENO_QHIZHPE.jpg"
                alt="Card image cap">
            </div>
            <div class="card-body">
              <h5 class="card-title">PAÚL JAVIER MORENO QHIZHPE</h5><hr />
              <h6>Docente investigador UTPL</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-4">
        <div class="card">
          <div class="row text-center">
            <div class="col-md-12">
              <img class="card-img-top" 
              src="./assets/img/JOSE_ALEJANDRO_LEON_FERNANDEZ.jpg"
                alt="Card image cap">
            </div>
            <div class="card-body">
              <h5 class="card-title">JOSÉ ALEJANDRO LEÓN FERNÁNDEZ</h5><hr />
              <h6>Docente investigador UTPL</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</section>
<div  class="py-2 team4 background">
<div class="width1">
  <div  class="row justify-content-center mb-4">
    <div  class="col-md-12 text-center">
      <h1  class="mb-4">Soporte tecnológico</h1>
        <h6>
          Trabajo conjunto entre el Club de Realidad Virtual y la Dirección de Tecnologías para la Educación.
        </h6>
    </div>
  </div>
  <div class="row justify-content-center" style="padding-left:1%">
    <div class="col-lg-2 mb-4">
      <div class="row text-center">
        <div class="col-md-12">
          <img src="./assets/img/Stalin_Carrion.jpg" alt="wrapkit" class="img-fluid rounded-circle">
        </div>
        <div  class="col-md-12 text-center">
          <div  class="pt-2">
            <h5  class="mt-4 font-weight-medium mb-0">Stalin Carrión</h5>
            <h6  class="subtitle mb-3">DESARROLLO UNITY</h6>
          </div>
        </div>
      </div>
    </div>
    <div  class="col-lg-2 mb-4">
      <div  class="row text-center">
        <div  class="col-md-12">
          <img src="./assets/img/Darwin_Calle.jpg" alt="wrapkit" class="img-fluid rounded-circle">
        </div>
        <div  class="col-md-12 text-center">
          <div  class="pt-2">
            <h5  class="mt-4 font-weight-medium mb-0">Darwin Calle</h5>
            <h6  class="subtitle mb-3">DISEÑO GRÁFICO</h6>
          </div>
        </div>
      </div>
    </div>
    
    <div  class="col-lg-2 mb-4">
      <div  class="row text-center">
        <div  class="col-md-12">
          <img src="./assets/img/Martha_Agila.jpg" alt="wrapkit" class="img-fluid rounded-circle">
        </div>
        <div  class="col-md-12 text-center">
          <div  class="pt-2">
            <h5  class="mt-4 font-weight-medium mb-0">Martha Agila</h5>
            <h6  class="subtitle mb-3">COORDINACIÓN DEL PROYECTO</h6>
          </div>
        </div>
      </div>
    </div>
    <div  class="col-lg-2 mb-4">
      <div  class="row text-center">
        <div  class="col-md-12">
          <img src="./assets/img/ROMERO_PARRA_ALEX_FERNANDO.jpg" alt="wrapkit" class="img-fluid rounded-circle">
        </div>
        <div  class="col-md-12 text-center">
          <div  class="pt-2">
            <h5  class="mt-4 font-weight-medium mb-0">Alex Romero</h5>
            <h6  class="subtitle mb-3">DESARROLLO ANGULAR</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<footer>
<div class="text-center p-3">
  © 2022 Copyright:
  <a class="text-dark" href="https://utpl.edu.ec/">UTPL</a>
</div>
</footer>